<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" height="24" width="24">
    <path
      d="M12,0A8,8,0,0,0,4,8c0,3.51,5,12,7.15,15.52a1,1,0,0,0,1.7,0C15,20,20,11.51,20,8A8,8,0,0,0,12,0Zm0,11.5A3.5,3.5,0,1,1,15.5,8,3.5,3.5,0,0,1,12,11.5Z"
      fill="currentColor"
    />
  </svg>
</template>
